export default "__VITE_ASSET__B25HS6uM__"